export const pushError = (state, {error}) => {
  state.errors.push(error)
}

export const popError = (state) => {
  state.errors.shift()
}



// WEBPACK FOOTER //
// ./src/store/errors/mutations.js